module.exports = __webpack_public_path__ + "img/3-10-1.6fd29166.png";